import { apiClient } from "lib/apiClient";
import { compactResearchParams } from "features/Research/constants";
import {
  IResearchClientProgressBucket,
  IResearchClientProgressRequest,
} from "features/Research/types";

export const getResearchClientProgress = async (
  request: IResearchClientProgressRequest
): Promise<IResearchClientProgressBucket[]> => {
  const response = await apiClient.get("/research/work-items/client-progress", {
    params: compactResearchParams(request),
  });
  return response.data;
};
